import { useTranslation } from 'react-i18next';
import useBrokersFunctions from './useBrokersFunctions';
import AppLayout from '../../components/AppLayout';
import { S, EmptyState } from '../regureStyles';
import SelectedBroker from './SelectedBroker';
import AddForm from './AddForm';
import Filter from './Filter';
import Header from './Header';
import Table from './Table';

const BrokersScreen = () => {
  const { t } = useTranslation();
  const {
    loading,
    error,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    selectedBroker,
    setSelectedBroker,
    openBrokerDetail,
    detailLoading,
    associatedClients,
    page,
    setPage,
    PAGE_SIZE,
    showAddForm,
    setShowAddForm,
    newBroker,
    setNewBroker,
    submitting,
    fetchBrokers,
    filtered,
    paginated,
    handleAddBroker,
    handleDeleteBroker,
  } = useBrokersFunctions();

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));

  if (selectedBroker) {
    return (
      <SelectedBroker
        associatedClients={associatedClients}
        selectedBroker={selectedBroker}
        setSelectedBroker={setSelectedBroker}
        showAddForm={showAddForm}
        setShowAddForm={setShowAddForm}
        newBroker={newBroker}
        setNewBroker={setNewBroker}
        submitting={submitting}
        handleAddBroker={handleAddBroker}
        handleDeleteBroker={handleDeleteBroker}
      />
    );
  }

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Header setShowAddForm={setShowAddForm} />

        <Filter search={search} setSearch={setSearch} setPage={setPage} statusFilter={statusFilter} setStatusFilter={setStatusFilter} filtered={filtered} />

        <div style={{ flex: 1, overflowY: 'auto', padding: '0 32px' }}>
          {loading || detailLoading ? (
            <div style={{ padding: 60, textAlign: 'center', color: S.textMuted }}>{t('screens.brokers.loading')}</div>
          ) : error ? (
            <div style={{ padding: 60, textAlign: 'center' }}>
              <div style={{ color: '#ef4444', fontWeight: 600, marginBottom: 12 }}>{error}</div>
              <button
                onClick={fetchBrokers}
                style={{ padding: '8px 20px', background: S.burgundy, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
              >
                {t('screens.brokers.retry')}
              </button>
            </div>
          ) : paginated.length === 0 ? (
            <EmptyState icon='briefcase' title={t('screens.brokers.emptyTitle')} description={t('screens.brokers.emptyDescription')} />
          ) : (
            <Table paginated={paginated} onSelect={openBrokerDetail} />
          )}
        </div>

        <div
          style={{
            padding: '14px 32px',
            borderTop: `1px solid ${S.borderLight}`,
            background: 'rgba(255,255,255,0.8)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: 13, color: S.textMuted }}>
            {t('screens.brokers.showingCount', { shown: paginated.length, total: filtered.length })}
          </span>
          {totalPages > 1 && (
            <div style={{ display: 'flex', gap: 4 }}>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button
                  key={p}
                  onClick={() => setPage(p)}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    border: p === page ? `1px solid ${S.burgundy}` : `1px solid ${S.borderLight}`,
                    background: p === page ? 'rgba(128,0,32,0.07)' : '#fff',
                    color: p === page ? S.burgundy : S.textSecondary,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  {p}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Add Broker Modal */}
      {showAddForm && (
        <AddForm setShowAddForm={setShowAddForm} newBroker={newBroker} setNewBroker={setNewBroker} submitting={submitting} handleAddBroker={handleAddBroker} />
      )}
    </AppLayout>
  );
};

export default BrokersScreen;
